import { BypassCheck } from "../exemptions.types";

export const categoryColors = {
  authentication: {
    backgroundClass: "tw-bg-primary-cobalt-blue-100",
    indicatorClass: "tw-bg-primary-cobalt-blue-800",
  },
  suspicious: {
    backgroundClass: "tw-bg-branding-orange-100",
    indicatorClass: "tw-bg-branding-orange-900",
  },
  malicious: {
    backgroundClass: "tw-bg-system-error-100",
    indicatorClass: "tw-bg-system-error-800",
  },
} as const;

export const bypassCheckConfig: Record<
  BypassCheck,
  {
    text: string;
    info: string;
    backgroundClass: string;
    width: number;
  }
> = {
  antispoof: {
    text: "anti-spoof-tab",
    info: "anti-spoof-tooltip",
    ...categoryColors.authentication,
    width: 78,
  },
  geoip: {
    text: "geoblocking-title",
    info: "geoblocking-verdict-description",
    ...categoryColors.authentication,
    width: 88,
  },
  spam: {
    text: "spam-legend",
    info: "spam-tooltip",
    ...categoryColors.suspicious,
    width: 48,
  },
  frequently_exploited_domains: {
    text: "frequently-exploited-domains-tab",
    info: "frequently-exploited-domains-tooltip",
    ...categoryColors.suspicious,
    width: 186,
  },
  graymail: {
    text: "graymail-tab",
    info: "graymail-tooltip",
    ...categoryColors.suspicious,
    width: 78,
  },
  suspicious_intent: {
    text: "suspicious-intent-checkbox",
    info: "suspicious-intent-tooltip",
    ...categoryColors.suspicious,
    width: 114,
  },
  known_malicious_sender: {
    text: "known-malicious-senders",
    info: "known-malicious-senders-description",
    ...categoryColors.suspicious,
    width: 160,
  },
  phishing: {
    text: "phishing-legend",
    info: "phishing-tooltip",
    ...categoryColors.malicious,
    width: 64,
  },
  malware: {
    text: "malware-legend",
    info: "malware-tooltip",
    ...categoryColors.malicious,
    width: 64,
  },
  malicious_intent: {
    text: "malicious-intent-checkbox",
    info: "malicious-intent-tooltip",
    ...categoryColors.malicious,
    width: 106,
  },
  fraud: {
    text: "fraud-legend",
    info: "fraud-tooltip",
    ...categoryColors.malicious,
    width: 48,
  },
};
